import { render } from "./Allntegrations.vue?vue&type=template&id=d70e934a&scoped=true"
import script from "./Allntegrations.vue?vue&type=script&lang=js"
export * from "./Allntegrations.vue?vue&type=script&lang=js"

import "./Allntegrations.vue?vue&type=style&index=0&id=d70e934a&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d70e934a"]])

export default __exports__